import React from 'react';
import { withRouter } from 'react-router-dom';
import '../../../css/huerto/modalsFichaCliente.css';
import FunctionGeneral from '../functionsGeneral';

function ModalFichaClienteDataActividad(props) {
    var dataDecisions = props.dataDecisions;
    let FechaLLamada = [];
    let NombreGestorDecision = [];
    let FechaAltaBD = [];
    let TipoDeDecision = [];
    let ObservacionesDecision = [];
    let UsuarioModif = [];
    let NombreCompletoUsuarioAlta = [];
    let FechaModifBD = [];
    let EstadoActiva = [];
    let listItems = [];

    for (let elemetn in dataDecisions) {
        if (dataDecisions[elemetn].FechaLLamada) {
            let dateFechaLLamada =
                dataDecisions[elemetn].FechaLLamada.split('T')[0];
            FechaLLamada.push(
                new FunctionGeneral().formatFecha(dateFechaLLamada.split('-'))
            );
        } else FechaLLamada.push('');

        if (dataDecisions[elemetn].FechaModifBD) {
            let dateFechaModifBD =
                dataDecisions[elemetn].FechaModifBD.split('T')[0];
            FechaModifBD.push(
                new FunctionGeneral().formatFecha(dateFechaModifBD.split('-'))
            );
        } else FechaModifBD.push('');

        if (dataDecisions[elemetn].NombreGestorDecision)
            NombreGestorDecision.push(
                dataDecisions[elemetn].NombreGestorDecision
            );
        else NombreGestorDecision.push('');

        if (dataDecisions[elemetn].FechaAltaBD) {
            let dateFechaAltaBD =
                dataDecisions[elemetn].FechaAltaBD.split('T')[0];
            FechaAltaBD.push(
                new FunctionGeneral().formatFecha(dateFechaAltaBD.split('-'))
            );
        } else FechaAltaBD.push('');

        if (dataDecisions[elemetn].TipoDeDecision) {
            TipoDeDecision.push(dataDecisions[elemetn].TipoDeDecision);
        } else TipoDeDecision.push('');

        if (dataDecisions[elemetn].ObservacionesDecision)
            ObservacionesDecision.push(
                dataDecisions[elemetn].ObservacionesDecision
            );
        else ObservacionesDecision.push('');

        if (dataDecisions[elemetn].UsuarioModif)
            UsuarioModif.push(dataDecisions[elemetn].UsuarioModif);
        else UsuarioModif.push('');

        if (dataDecisions[elemetn].NombreCompletoUsuarioAlta)
            NombreCompletoUsuarioAlta.push(
                dataDecisions[elemetn].NombreCompletoUsuarioAlta
            );
        else NombreCompletoUsuarioAlta.push('');

        if (dataDecisions[elemetn].EstadoActiva) {
            if (dataDecisions[elemetn].EstadoActiva == 'N')
                EstadoActiva.push('No');
            else if (dataDecisions[elemetn].EstadoActiva == 'S')
                EstadoActiva.push('Si');
            else EstadoActiva.push(dataDecisions[elemetn].EstadoActiva);
        } else EstadoActiva.push('');
    }

    if (dataDecisions) {
        for (let number in dataDecisions) {
            listItems.push(
                <li key={number} className="labelConsT">
                    <div className="items-ul u-text-brand" />
                    <section style={{ position: 'relative', bottom: '15px' }}>
                        <div>
                            <div className="o-layout__item u-1/1">
                                <label className="u-text-muted u-2/3">
                                    Fecha Actividad:
                                </label>
                                <label className="u-text-muted u-1/3">
                                    Gestor Decisión :
                                </label>
                            </div>
                            <div className="o-layout__item u-1/1">
                                <label className="u-text-brand u-2/3">
                                    {FechaLLamada[number]}
                                </label>
                                <label className="u-text-brand u-1/3">
                                    {NombreGestorDecision[number]}
                                </label>
                            </div>
                        </div>

                        <div className="fc-margintop-5">
                            <div className="o-layout__item u-1/1">
                                <label className="u-text-muted u-2/3">
                                    Fecha Alta:
                                </label>
                                <label className="u-text-muted u-1/3">
                                    Usuario Alta:
                                </label>
                            </div>
                            <div className="o-layout__item u-1/1">
                                <label className="u-text-brand u-2/3">
                                    {FechaAltaBD[number]}
                                </label>
                                <label className="u-text-brand u-1/3">
                                    {NombreCompletoUsuarioAlta[number]}
                                </label>
                            </div>
                        </div>

                        {FechaModifBD[number] != '' &&
                            FechaModifBD[number] != null && (
                                <div className="fc-margintop-5">
                                    <div className="o-layout__item u-1/1">
                                        <label className="u-text-muted u-2/3">
                                            Fecha Modificaión:
                                        </label>
                                        <label className="u-text-muted u-1/3">
                                            Usuario Moficado:
                                        </label>
                                    </div>
                                    <div className="o-layout__item u-1/1">
                                        <label className="u-text-brand u-2/3">
                                            {FechaModifBD[number]}
                                        </label>
                                        <label className="u-text-brand u-1/3">
                                            {UsuarioModif[number]}
                                        </label>
                                    </div>
                                </div>
                            )}

                        <div className="fc-margintop-5">
                            <div className="o-layout__item u-1/1">
                                <label className="u-text-muted u-2/3">
                                    Decisión:
                                </label>
                                <label className="u-text-muted u-1/3">
                                    Activa:
                                </label>
                            </div>
                            <div className="o-layout__item u-1/1">
                                <label className="u-text-base  u-2/3">
                                    {TipoDeDecision[number]}
                                </label>
                                <label className="u-text-base  u-1/3">
                                    {EstadoActiva[number]}
                                </label>
                            </div>
                        </div>

                        <div className="fc-margintop-5">
                            <div className="o-layout__item u-1/1">
                                <label className="u-text-muted u-2/3">
                                    Observación:
                                </label>
                                <label className="u-1/3"></label>
                            </div>
                            <div className="o-layout__item u-1/1">
                                <label className="u-text-base u-text-left">
                                    {ObservacionesDecision[number]}
                                </label>
                            </div>
                        </div>
                    </section>
                </li>
            );
        }
    }

    return (
        <div className="c-modal" aria-hidden={'false'}>
            <div className="c-modal__overlay js-modal-close"></div>
            <div
                className="c-modal__wrapper modalFichaCliente"
                role="dialog"
                aria-labelledby="foo-bar-baz"
            >
                <header className="c-modal__header">
                    <div className="o-layout__item u-11/12 ">
                        <div className="o-layout__item u-1/1">
                            <div className="c-icon c-icon--[semantic-chat] colorBlue iconContrato" />
                            <label className="u-h3 u-ml-xsmall">
                                Actividad
                            </label>
                        </div>
                    </div>

                    <div className="o-layout__item u-1/12">
                        <button
                            onClick={() => props.setModalActividad(false)}
                            className="c-modal__close-btn  js-modal-close"
                            type="button"
                            aria-label="Close this dialog window."
                        />
                    </div>

                    <div className="o-layout__item u-1/1 ">
                        <h4 className="o-layout__item u-1/1 u-text-left u-text-muted u-h4 fc-margintop-10">
                            Actividad Pasada
                        </h4>
                    </div>
                </header>

                <div className="c-modal__content fc-margintop-5">
                    <div className="gridContainerModal gridContainerModalDataActividad">
                        <div className="o-layout__item u-1/1">
                            <ul className="ul-FC">{listItems}</ul>
                        </div>
                    </div>
                    <div className="o-layout__item u-1/1">
                        <button
                            className="CancelActividad u-text-brand c-btn"
                            onClick={() => props.setModalActividad(false)}
                        >
                            CERRAR
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default withRouter(ModalFichaClienteDataActividad);
